<template>
  <div class="row">
    <div class="col-md-2" style="margin-bottom: 15px">
      <div class="img">
        <lightbox
          v-if="image"
          :show="showLightbox"
          :src="image"
          @close="showLightbox = false"
        >
        </lightbox>
        <img
          v-if="image"
          class="img-responsive lightbox"
          :src="image"
          @click.prevent="showLightbox = true"
        />
        <img
          v-else
          class="img-responsive"
          src="/static/images/unknown.png"
          srcset="/static/images/unknown@2x.png 2x"
        />
      </div>
    </div>
    <div class="col-md-10">
      <table class="table table-responsive">
        <tbody>
          <tr v-if="status">
            <th style="border-top: none">Status</th>
            <td style="border-top: none">
              <EpcStatus :status="status" />
            </td>
          </tr>
          <tr>
            <th>{{ $t('gtin') }}</th>
            <td>{{ product.gtin }}</td>
          </tr>
          <tr>
            <th>{{ $t('brand_name') }}</th>
            <td>
              <template
                v-if="
                  typeof product.brandName !== 'undefined' &&
                  product.brandName.length > 0
                "
              >
                <lang-string
                  v-for="brandName in product.brandName"
                  :key="brandName.language"
                  :lang="brandName.language"
                  :value="brandName.value"
                  ><br
                /></lang-string>
              </template>
              <span v-else class="unknown">{{ $t('unknown') }}</span>
            </td>
          </tr>
          <tr>
            <th>{{ $t('product_description') }}</th>
            <td>
              <template
                v-if="
                  typeof product.description !== 'undefined' &&
                  product.description.length > 0
                "
              >
                <lang-string
                  v-for="description in product.description"
                  :key="description.language"
                  :lang="description.language"
                  :value="description.value"
                  ><br
                /></lang-string>
              </template>
              <span v-else class="unknown">{{ $t('unknown') }}</span>
            </td>
          </tr>
          <tr>
            <th>{{ $t('product_image_url') }}</th>
            <td class="overflow-hidden">
              <template
                v-if="
                  typeof product.image !== 'undefined' &&
                  Array.isArray(product.image) &&
                  product.image.length > 0
                "
              >
                <lang-string
                  v-for="image in product.image"
                  :key="image.language"
                  :lang="image.language"
                  :value="image.value"
                  tag="a"
                  :href="image.value"
                  target="_blank"
                  rel="noopener"
                  ><br
                /></lang-string>
              </template>
              <span v-else class="unknown">{{ $t('unknown') }}</span>
            </td>
          </tr>
          <tr>
            <th>{{ $t('global_product_category') }}</th>
            <td>
              <template v-if="product.gpc">{{ product.gpc }}</template>
              <span v-else class="unknown">{{ $t('unknown') }}</span>
            </td>
          </tr>
          <tr>
            <th>{{ $t('net_content') }}</th>
            <td>
              <template
                v-if="
                  typeof product.netContents !== 'undefined' &&
                  Array.isArray(product.netContents) &&
                  product.netContents.length > 0
                "
              >
                <span v-html="product.netContents.join(', ')"></span>
              </template>
              <span v-else class="unknown">{{ $t('unknown') }}</span>
            </td>
          </tr>
          <tr>
            <th>
              {{ $tc('country_of_sale', product.countriesOfSale.length) }}
            </th>
            <td>
              <template v-if="product.countriesOfSale.length > 0">
                {{ product.countriesOfSale.join(', ') }}
              </template>
              <span v-else class="unknown">{{ $t('unknown') }}</span>
            </td>
          </tr>
          <links-tr :linkSet="linkSet">{{ $t('targets') }}</links-tr>
          <tr>
            <th style="border-bottom: 0">{{ $t('last_update') }}</th>
            <td style="border-bottom: 0">
              {{ saveGet(this.product, '', 'updatedOn') }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Gs1Alert from '@/components/alerts/Gs1Alert'
import Gs1AlertVerified from '@/components/alerts/Gs1AlertVerified'
import LangString from '@/components/LangString'
import Lightbox from '@/components/Lightbox'
import Licence from '@/components/Licence'
import { saveGet } from '../mixins/saveGet'
import { mapProduct } from '../mixins/mapProduct'
import EpcStatus from './EpcStatus.vue'
import LinksTr from '@/components/LinksTr.vue'

export default {
  name: 'Product',
  props: ['product', 'status', 'linkSet'],
  components: {
    EpcStatus,
    Licence,
    Gs1Alert,
    Gs1AlertVerified,
    LangString,
    Lightbox,
    LinksTr
  },
  mixins: [saveGet, mapProduct],
  data() {
    return {
      showLightbox: false
    }
  },
  computed: {
    image() {
      if (
        typeof this.product.image !== 'undefined' &&
        Array.isArray(this.product.image) &&
        this.product.image.length > 0
      ) {
        return this.product.image[0].value
      }
    }
  },
  i18n: {
    messages: {
      de: {
        gtin: 'GTIN',
        brand_name: 'Marke',
        product_description: 'Produktbeschreibung',
        product_image_url: 'Produktabbildung (URL)',
        global_product_category: 'Kategorie (GPC)',
        net_content: 'Nettofüllmenge',
        country_of_sale: 'Verkaufsland | Verkaufsländer',
        unknown: 'Unbekannt',
        last_update: 'Zuletzt geändert',
        language: 'Sprache',
        targets: 'Produktbezogene Verlinkungen'
      },
      en: {
        gtin: 'GTIN',
        brand_name: 'Brand name',
        product_description: 'Product description',
        product_image_url: 'Product image URL',
        global_product_category: 'Global product category',
        net_content: 'Net content',
        country_of_sale: 'Country of sale | Countries of sale',
        unknown: 'Unknown',
        last_update: 'Last update',
        language: 'Language',
        targets: 'Product related links'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Product.vue